export class ExpensesClaimModel {
  value: string;
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/ecv-project/time-tracker/time-tracker-model/expenses-claim.model.ts